import { useCallback } from 'react';
import { assistUser } from '../services/help/assistUser';
import { getTraceContext } from '../services/audit/traceContext';

export function useSupportChat() {
  const assist = useCallback((input: Parameters<typeof assistUser>[0]) => assistUser(input), []);
  const traceContext = useCallback(() => getTraceContext(), []);
  return { assistUser: assist, getTraceContext: traceContext };
}
